export const GET_WORKSPACES = 'GET_WORKSPACES';
export const GET_WORKSPACE_BY_ID = 'GET_WORKSPACE_BY_ID';
export const UPDATE_WORKSPACE = 'UPDATE_WORKSPACE';
export const DELETE_WORKSPACE = 'DELETE_WORKSPACE';
export const CREATE_WORKSPACE = 'CREATE_WORKSPACE';
export const GET_WORKSPACE_USERS = 'GET_WORKSPACE_USERS';
export const ADD_WORKSPACE_USER = 'ADD_WORKSPACE_USER';
export const DELETE_WORKSPACE_USER = 'DELETE_WORKSPACE_USER';
export const SET_WORKSPACE_TO_DEFAULT = 'SET_WORKSPACE_TO_DEFAULT';
